import script from "./TabsVue.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsVue.vue?vue&type=script&setup=true&lang=js"

import "./TabsVue.vue?vue&type=style&index=0&id=9217b768&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9217b768"]])

export default __exports__